// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a07f9f4d6cd8ed680108","655":"a2ea801c3a90bd5b2dac"}[chunkId] + ".js";
};